import React from 'react';
import { BackArrowIcon, BackButtonText, IconButton } from './BackButton.styles';

const BackButton: React.FunctionComponent<{goBack: () => void;}> = ({ goBack }) => 
{
    return (
        <IconButton onClick={goBack}>
            <BackArrowIcon />
            <BackButtonText>Back</BackButtonText>
        </IconButton>
    );
};

export default BackButton;
